import { useNavigate } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import Button from "../common/Button";
import { siteData } from "../data/siteData";

const HeroSection = () => {
  const navigate = useNavigate();

 const scrollToSection = (id) => {
  const section = document.getElementById(id);
  if (!section) return;

  section.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center py-10 overflow-hidden"
    >
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-50 via-teal-50 to-green-50" />

      {/* Pattern Overlay */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23059669' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-block px-4 py-2 bg-emerald-100 text-emerald-800 rounded-full text-sm font-medium">
              Premium Township by {siteData.company.parentCompany}
            </div>

            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              A Township Where Life Naturally{" "}
              <span className="text-emerald-600">Blooms</span>
            </h1>

            <p className="text-xl text-gray-600 leading-relaxed">
              Experience the perfect harmony of classical architecture, lush
              green landscapes, and fragrant gardens at {siteData.company.name}{" "}
              — where modern comfort meets natural serenity.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4">
              <Button
                onClick={() => navigate("/contact")}
                variant="primary"
                className="group"
              >
                <span>Book Site Visit</span>
                <ArrowRight
                  size={20}
                  className="ml-2 group-hover:translate-x-1 transition-transform"
                />
              </Button>

              <Button
                onClick={() => scrollToSection("premium-villas")}
                variant="secondary"
              >
                Explore Villas
                
                <ArrowRight
                  size={20}
                  className="ml-2 group-hover:translate-x-1 transition-transform"
                />
              </Button>
            </div>

            {/* Contact Info */}
            <div className="flex items-center space-x-8 pt-4">
              <div className="flex items-center space-x-2">
                <Phone size={20} className="text-emerald-600" />
                <a
                  href={`tel:${siteData.contact.phone}`}
                  className="text-gray-700 hover:text-emerald-600 transition-colors"
                >
                  {siteData.contact.phone}
                </a>
              </div>

              <div className="flex items-center space-x-2">
                <FaWhatsapp size={20} className="text-emerald-600" />
                <a
                  href={`https://wa.me/${siteData.contact.whatsapp.replace(
                    /[^0-9]/g,
                    ""
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:text-emerald-600 transition-colors"
                >
                  WhatsApp
                </a>
              </div>
            </div>
          </div>

          {/* Right Illustration */}
          <div className="relative group">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl">
              <div className="aspect-[1200/761]">
                <img
                  src="/images/villaimages/2450_1.jpg"
                  alt="Floret Town Villa"
                  
                  className="w-full h-full object-cover transition-transform duration-700 ease-out
                  group-hover:scale-110"
                />
              </div>
            </div>

            {/* Decorative Blobs */}
            <div className="absolute -bottom-6 -right-6 w-72 h-72 bg-emerald-200 rounded-full blur-3xl opacity-20" />
            <div className="absolute -top-6 -left-6 w-72 h-72 bg-teal-200 rounded-full blur-3xl opacity-20" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
